import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import React from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'

import Login from '../login'
import Layout from './pages/layout.js'
import Calendar from './pages/calendar'
import Classes from './pages/events'
import ClassBookings from './pages/eventBookings'
import PartyAdditions from './pages/partyAdditions'
import MascotAdditions from './pages/mascotAdditions'
import Themes from './pages/themes'
import Banner from './pages/banner'
import Insights from './pages/insights'
import Inventory from './pages/inventory'
import DateRanges from './pages/dateRanges'
import Staff from './pages/staff'
import ChangeLogs from './pages/changeLogs'

import News from './pages/news'

export function Dashboard(props) {
  return (
    <div>
      <main>
        <Switch>
          <PrivateRoute
            from="/dashboard/calendar"
            component={Calendar}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/eventBookings"
            component={ClassBookings}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/events"
            component={Classes}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/partyAdditions"
            component={PartyAdditions}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/themes"
            component={Themes}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/mascotAdditions"
            component={MascotAdditions}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/news"
            component={News}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/banner"
            component={Banner}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/banner"
            component={Banner}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/insights"
            component={Insights}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/inventory"
            component={Inventory}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/dateRanges"
            component={DateRanges}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/staff"
            component={Staff}
            userLoggedIn={props.userLoggedIn}
          />
          <PrivateRoute
            from="/dashboard/changeLogs"
            component={ChangeLogs}
            userLoggedIn={props.userLoggedIn}
          />
        </Switch>
      </main>
    </div>
  )
}

function PrivateRoute({ component: Component, userLoggedIn, from }) {
  return (
    <Route
      render={props => {
        return userLoggedIn ? (
          <Layout Component={Component} {...props} />
        ) : (
          <Redirect
            component={Login}
            from={from}
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }}
    />
  )
}

const mapStateToProps = ({ admin }) => ({
  admin: admin,
  userLoggedIn: admin.userLoggedIn
})

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard)
